module.exports = __webpack_public_path__ + "media/images/sp/stores/shinjuku/shinjuku_sns_03-392360a1a7724b03d9815f5dba00d26d.jpg";